import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { sanitize } from 'hast-util-sanitize';
import Rehype from 'rehype-react';
import schema from '../utils/schema-hast-sanitize.json';
import { toHtmlSanitize } from '../utils/remark-html';

const renderAst = new Rehype({
  createElement: React.createElement
}).Compiler;

export const HTMLContent = ({ content, className }) => (
  <div className={className}>{renderAst(sanitize(content, schema))}</div>
);

/**
 * Designed for use with Netlify Preview components that need to render the main body
 * of the markdown file.
 */
export const MarkdownContent = ({ content, className }) => {
  return (
    <div
      className={className}
      /* eslint-disable-next-line react/no-danger */
      dangerouslySetInnerHTML={{ __html: toHtmlSanitize(content, { removeWrappingPTag: false }) }}
    />
  );
};

const Content = ({ content, className }) => {
  const html = ReactDOMServer.renderToStaticMarkup(content);
  // eslint-disable-next-line react/no-danger
  return <div className={className} dangerouslySetInnerHTML={{ __html: toHtmlSanitize(html) }} />;
};
export default Content;
